import {StatusOfTask} from "./status-of-task";

export type Color = string;
export const StatusOfNotificationTaskColor: Map<StatusOfTask, Color> = new Map()
  .set(StatusOfTask.Completed, 'green')
  .set(StatusOfTask.InProgress, 'orange')
  .set(StatusOfTask.NotStarted, 'red');
